import React, {useEffect , useState} from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import axios from "axios";
import { API_URL } from "../../constent";
import {useParams} from 'react-router-dom';

import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  BackTo,
  PreviewCard,
  ReactDataTable,
  Row,
  Col,
} from "../../components/Component";

var userData = JSON.parse(localStorage.getItem('userData'));
var role = userData?.[0]?.role;

const SingleCategory = () => {

const [policydata , SetProduct] = useState([]);
const [loading, setLoading] = useState(true);
const params = useParams()
var category_id = params.id;

useEffect(()=>{
        axios.get( `${API_URL}getsinglepolicy/${category_id}`).then((result)=>
        {
            console.log(result.data);
            SetProduct(result.data);
            setLoading(false);
        }) 
 },[])

 if (loading) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  return (
    <React.Fragment>
      <Head title="Category List"/>
      <Content>
        <BlockHead size="sm">
        <Row className="g-gs">
                <Col sm="12">
                     <p className="top_head_css">Add &gt; {policydata[0]['policy_name']}</p>
                </Col>
          </Row>
        </BlockHead>
        <Block size="lg">
        <ul className="category-list">
               
        {category_id === '1' && (
          <>
            <li key='0'><Link to={`addsheeethealth/1/${category_id}`}>RENEWAL</Link></li>
            <li key='1'><Link to={`addsheeethealth/2/${category_id}`}>NEW BUSINESS</Link></li>
          </>
        )}

        {category_id === '4' && (
          <>
            <li key='0'><Link to={`addsheeet/1/${category_id}`}>RENEWAL</Link></li>
            <li key='1'><Link to={`addsheeet/2/${category_id}`}>NEW BUSINESS</Link></li>
          </>
        )}

        {category_id === '10' && (
          <>
            <li key='0'><Link to={`addsheeetnonmotor/1/${category_id}`}>RENEWAL</Link></li>
            <li key='1'><Link to={`addsheeetnonmotor/2/${category_id}`}>NEW BUSINESS</Link></li>
          </>
        )}
        </ul>

        </Block>

      </Content>
    </React.Fragment>
  );
};
export default SingleCategory;
